
require('./bootstrap');


// Here is the popup effect for images
// import 'magnific-popup';
// let caption = window.$('a.mpopup, .wp-caption > a');
// caption.length && caption.magnificPopup({
//   type: 'image',
//   closeOnContentClick: true,
//   image: {
//     verticalFit: true,
//     titleSrc: function (item) {
//       return item.el.siblings('.wp-caption-text').text();
//     }
//   }
// });

// Here is the popup effect for a gallery
// let gallery = window.$('.popup-gallery');
// gallery.length && gallery.magnificPopup({
//   delegate: 'a',
//   type: 'image',
//   tLoading: 'Loading image #%curr%...',
//   mainClass: 'mfp-img-mobile',
//   gallery: {
//     enabled: true,
//     navigateByImgClick: true,
//     preload: [0,1] // Will preload 0 - before current, and 1 after the current image
//   },
//   image: {
//     tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
//     titleSrc: function(item) {
//       return item.el.attr('title');
//     }
//   }
// });


// This is for the mobile menu
import Slideout from 'slideout/dist/slideout';
var mobile = new Slideout({
  'panel': document.getElementById('app'),
  'menu': document.getElementById('mobile-nav'),
  'padding': 256,
  'tolerance': 70,
  'side': 'left',
  'touch': false
});

// This allows the user to click on the overlay and close the mobile menu
var appOverlay = document.getElementById('app-overlay');
document.querySelector('.toggle-nav').addEventListener('click', function() {
  mobile.toggle();
  appOverlay.style.display = "block";
});
appOverlay.addEventListener('click', function() {
  appOverlay.style.display = "none";
  mobile.toggle();
});

// This is the go to button
window.$(document).ready($ => {
	$(".go-to-module > a").click(function(e) {
		mobile.close();
		const elm = document.querySelector($(this).attr('href'))
		elm && e.preventDefault()
		elm && elm.scrollIntoView({
			behavior: 'smooth'
		})
		document.getElementById('app-overlay').style.display = "none";
	})
})

// window.$(($) => {
// 	//$(window).on('scroll', applyMenuClassOnScroll)
// })

// function applyMenuClassOnScroll() {
// 	let scrollPos = window.$(window).scrollTop()
// 	window.$('#navigation-block .nav-menu > li.menu-item > a').each(function () {
// 		let currLink = window.$(this)
// 		let refElement = window.$(currLink.attr("href"))

// 		if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
// 			window.$('navigation-block .nav-menu > li.menu-item').removeClass("active")
// 			currLink.parent().addClass("active")
// 		}
// 		else {
// 			currLink.parent().removeClass("active")
// 		}
// 	})
// }



// WEBPACK FOOTER //
// ./assets/js/app.js